import { List } from 'immutable';

export default function getSliceResult(slice: any, resultKey = 'result') {
  return (state: any) => state.getIn([slice, 'data', resultKey], List());
}
